import { Container, FormLabel, Row } from 'react-bootstrap';
import { useSelector } from "react-redux";
import React, {useEffect} from 'react'
import UserService from './services/user.serviceaux';

export const getUserRoles = async (userId) => {
    try {
        const response = await UserService.get(userId);
        const respdata = response.data;
        //console.log(userId);
        //console.log(respdata);
        if (respdata.length > 0) {
            return (response.data[0].roles.map((a) => a.id));
        }
        else {
            return [];
        }        
    } catch (e) {
        // a type error is logged in the browser dev tools here :(
        // the cause of the error is that props.user is empty at the beginning...
        // but it doesn't seem to be affecting anything.
        // so, I think we can safely ignore it.. or not?
        //console.log(e);
        return [];
    }
};

export function dtForInputDate(dt) {
    var newDate = new Date(dt);
    var dtDate = newDate.getUTCFullYear() + '-' + (newDate.getUTCMonth()+1).toString().padStart(2,'0') + '-' + newDate.getUTCDate().toString().padStart(2,'0');    
    return dtDate;
}


export function dtFormatter(dt, type) {    
    var options;
    switch(type) {
        case 1: // Fri Dec 20 2024
            // Request a weekday along with a long date
            options = {
                weekday: "short",
                year: "numeric",
                month: "short",
                day: "numeric",
            };
            // An application may want to use UTC and make that visible
            options.timeZone = "UTC";
            options.timeZoneName = "short";
            return dt.toLocaleDateString(undefined, options);

        case 2: // Fri Dec 20 2024 8:25 p.m.
            options = {
                weekday: "short",
                year: "numeric",
                month: "short",
                day: "numeric",                
                hour: "numeric",
                minute: "numeric",
                timeZone: "UTC",
                timeZoneName: "short",
            };
            return Intl.DateTimeFormat("en-US", options).format(dt);  

        case 3: // 2025-01-04 06:00:00 // To save this value in the database. 
            // Use this function when saving a date selected from an input type date
            // This way the stored value will be consistent with UTC 
            // Use the function like this: 
            // dt_to_save = dtFormatter(e.target.valueAsNumber,3);
            let localDate = new Date(dt);
            const now_utc = new Date(localDate.toUTCString().slice(0, -4));
            console.log(now_utc.toString());
            return now_utc.toString(); // it compensates the time zone
    }
}

export function checkIfObjectNull(obj) {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
}

export function compareItemQuantities(arr1,arr2,keyarr1,qtyarr1, keyarr2,qtyarr2) {
    // arr1 is the array of totals
    // arr2 is the array of partials

    const itemMap = new Map();
    
    arr2.forEach(item => {
        itemMap.set(item[keyarr2], item[qtyarr2]);
    });
    console.log(itemMap);
    
    for (const item of arr1) {
        const correspondingQty = parseFloat(itemMap.get(item[keyarr2]));
        const itemqty = parseFloat(item[qtyarr1]);
        console.log(itemMap.get(item[keyarr1]));
        console.log(item[qtyarr1]);
        if (correspondingQty !== undefined && correspondingQty < itemqty) {
            return 2;
        }
    }
    return 3;
}

export function movementStatusTexts(movementType) {
    let movementTexts = {};
    switch (movementType) {
        case 1:
            movementTexts.movementName = "Purchase Order"; 
            movementTexts.statusFieldName = "postatus";
            movementTexts.sourceFieldName = "supplier.suppliername";
            movementTexts.statuses = {
                1: "Raised",
                2: "Partially received",
                3: "Received",
                4: "Paid",
                5: "Cancelled"
            };   
            break;
        case 4:
            movementTexts.movementName = "Wastage"; 
            movementTexts.statusFieldName = "wastagestatus"; // not added yet to the table.
            movementTexts.sourceFieldName = "";
            movementTexts.statuses = {
                1: "Raised",
                2: "Partially received",
                3: "Received",
                4: "Paid",
                5: "Cancelled"
            };   
            break;            
        case 6:
            movementTexts.movementName = "Reception"; 
            movementTexts.statusFieldName = "receptionpaymentstatus";
            movementTexts.sourceFieldName = "";
            movementTexts.statuses = {
                1: "Raised",
                2: "Paid",
                3: "Cancelled"
            };   
            break;
        case 8:
            movementTexts.movementName = "Bookin Request"; 
            movementTexts.statusFieldName = "bookinrequeststatus";
            movementTexts.sourceFieldName = "job.jobtitle";
            movementTexts.statuses = {
                1: "Raised",
                2: "Partially delivered",
                3: "Delivered",
                5: "Cancelled",
            };   
            break;            
    } 
    return movementTexts;   
}


//const NewReception = (props) => {

export const PageHeader = () => {    
    const { user: currentUser } = useSelector((state) => state.auth);	
	useEffect(() => {
		if (currentUser) {
            //console.log(currentUser);
			// these are the role ids from roles table
		}
	}, [currentUser]);  
      
    var newDate = new Date();
    var gtDate = newDate.getDate().toString().padStart(2,'0') + '-' + (newDate.getMonth()+1).toString().padStart(2,'0') + '-' + newDate.getFullYear();
    return (
        <>
        <Container>
            <Row className='mt-2'>

                <FormLabel style={{fontSize:"0.8em",textAlign:"right", maxWidth:"80vw"}}>
                    Sesión iniciada: {currentUser.email}
                </FormLabel>
                <FormLabel style={{fontSize:"0.8em",textAlign:"right", maxWidth:"80vw"}}>
                    Fecha actual: {gtDate}
                </FormLabel>                
                <p>
                    
                </p>
                <hr/>       
            </Row>
        </Container>
        </>
    )
}



